import styled from 'styled-components'

const Dot = styled.span`
  display: block;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.gray4};
`

export default Dot
